$bog_bzrl_app_profile $mol_view
	opened? false
	toggle? null
	theme_auto $bog_theme_auto
	profile_entity null
	sub /
		<= Panel $mol_pop_over
			Anchor <= Button $mol_button_minor
				click? <=> toggle?
				sub /
					<= Avatar $mol_image
						uri <= avatar_uri \
			bubble_content /
				<= Card $mol_card
					Content <= Menu $mol_list
						rows /
							<= Header $mol_view
								sub /
									<= Header_top $mol_view
										sub /
											<= Avatar_large $bog_bzrl_app_profile_avatar
												profile <= profile_entity
											<= Theme_toggle $bog_theme_toggle
												theme_auto <= theme_auto
									<= Name $mol_string_button
										value? <=> name? \
										hint @ \Click on me
									<= Id $mol_dimmer
										haystack <= profile_id \
